<template>
  <div>
    <!-- Navbar AppNavbarVerticalLayout -->
    <b-navbar
      class="header-navbar navbar navbar-shadow align-items-center"
      style="z-index: 2;"
    >
      <div class="navbar-container d-flex content align-items-center">
        <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
          <!-- Bookmarks Container -->
          <!-- <bookmarks /> -->
          <!-- <span><h3>Reportes y Visor de Mapas de Gs Encuesta</h3></span> -->
          <b-form-group
            label="Dependencia"
            label-for="proyecto"
            style="margin-right: 10px !important"
          >
            <b-form-select
              v-model="selectProyecto"
              type="select"
              class="custom-select"
              @change="getSelectedProyecto"
            >
              <option value="">
                SELECCIONE::
              </option>
              <option
                v-for="proy in optionProyecto"
                :key="proy.idProyecto"
                :value="proy.idProyecto"
              >
                {{ proy.nombre }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Encuesta"
            label-for="Encuesta"
            @change="getSelectedEncuesta"
          >
            <b-form-select
              v-model="selectEncuesta"
              type="select"
              class="custom-select"
            >
              <option value="">
                TODOS::
              </option>
              <option
                v-for="quiz in optionEncuesta"
                :key="quiz.idEncuesta"
                :value="quiz.idEncuesta"
              >
                {{ quiz.titulo }}
              </option>
            </b-form-select>
          </b-form-group>
          <span
            style="padding: 5px;"
          >
            <feather-icon
              v-b-tooltip.hover.bottom="infoEncuesta"
              icon="InfoIcon"
            />
          </span>
          <span
            style="padding: 5px;"
          >
            <b-badge
              v-if="metaEncuesta != 0"
              pill
              variant="light-primary"
            >
              Meta: {{ metaEncuesta }}
            </b-badge>
          </span>
          <!-- <span
            style="padding: 5px;"
          >
            <download-excel
              v-show="excelFicha"
              class="btn btn-default"
              :fields="json_fields"
              :fetch="()=>{return getFicha()}"
              worksheet="Ficha"
              name="reporte_ficha.xls"
            >
              <b-img
                :src="imgExcel"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Fichas"
              />
            </download-excel>
          </span> -->
          <span
            v-show="excelFichaConsolidado && userProfile.idPerfil!==4"
            style="padding: 5px; margin-right: 25px"
          >
            <a
              @click="generarConsolidado2"
            >
              <b-img
                :src="imgExcel"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Consolidado de Fichas por preguntas"
              />
            </a>
          </span>
          <span
            v-show="excelFichaConsolidado && userProfile.idPerfil!==4"
            style="margin-left: -20px;"
          >
            <a
              @click="generarConsolidado"
            >
              <b-img
                :src="imgExcelCons"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Consolidado de Fichas"
              />
            </a>
          </span>
        </div>
        <b-navbar-nav
          style="width:30%"
        >
          <b-form-datepicker
            id="fechaInicio"
            v-model="fechaInicio"
            class="mb-1"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es"
            placeholder="Fecha Inicio"
            style="margin-right:6px !important"
          />
          <b-form-datepicker
            id="fechaFinal"
            v-model="fechaFinal"
            class="mb-1"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es"
            placeholder="Fecha Final"
          />
        </b-navbar-nav>
      </div>
    </b-navbar>
    <br>
    <!--/ Navbar -->
    <section
      id="dashboard-ecommerce"
    >
      <b-row
        class="match-height"
      >
        <b-col
          sm="4"
        >
          <encuestador
            ref="refEncuestado"
            :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
          />
        </b-col>
        <b-col
          sm="4"
        >
          <report
            ref="refReport"
            :form-type-ubigeo="formTypeUbigeo"
          />
        </b-col>
        <b-col
          sm="4"
        >
          <GoogleMap
            ref="refGoogleMaps"
            :latitude="latitude"
            :longitude="longitude"
            :title="title"
            @refetch-data="refetchDataMapa"
          />
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
// import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import useAppConfig from '@core/app-config/useAppConfig'
import { BRow, BCol, BNavbar, BNavbarNav, BFormDatepicker, BBadge, BFormSelect, BFormGroup, VBTooltip, BImg } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import store from '@/store'
import { _ } from 'vue-underscore'
import { showToast } from '@/helpers'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
// import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import Encuestador from './Encuestador.vue'
import Report from './Report.vue'
import GoogleMap from './GoogleMap.vue'
import imgExcel1 from '../../../assets/images/encuesta/excel.png'
import imgExcel2 from '../../../assets/images/encuesta/excel1.png'

export default {
  components: {
    // AppCustomizer,
    BRow,
    BCol,
    BNavbar,
    BNavbarNav,
    BFormDatepicker,
    BFormSelect,
    BImg,
    BFormGroup,
    BBadge,
    /* Componentes */
    Encuestador,
    GoogleMap,
    Report,
    // LayoutVertical,
    // AppNavbarVerticalLayout,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
      data: {},
      stateMapa: false,
      formTypeUbigeo: '',
      dataMap: [],
      optionProyecto: [],
      optionEncuesta: [],
      dataReport: {},
      totalBeneficiario: 0,
      userData: JSON.parse(localStorage.getItem('userData')),
      userProfile: JSON.parse(localStorage.getItem('userData')),
      meta: 0,
      totalFicha: 0,
      selectProyecto: '',
      selectEncuesta: '',
      infoEncuesta: '',
      excelFicha: false,
      excelFichaConsolidado: false,
      selectUsuario: '',
      imgExcel: imgExcel1,
      imgExcelCons: imgExcel2,
      metaEncuesta: 0,
      fechaInicio: '',
      fechaFinal: '',
      dataEncuestador: [],
      isAddNewSidebarActive: false,
      isBusyReport: false,
      latitude: -6.0220945,
      longitude: -76.9884157,
      title: 'Título de Marcador',
      json_fields: {
        idFicha: 'idFicha',
        institucion: 'institucion',
        proyecto: 'proyecto',
        EncuestaTitulo: 'encuestaTitulo',
        encuestadoNombre: 'encuestadoNombre',
        encuestadoDocumento: 'encuestadoDocumento',
        latitud: 'latitud',
        longitud: 'longitud',
        fechaInicio: 'fechaInicio',
        fechaFinal: 'fechaFinal',
        // tiempoTranscurrido: 'TiempoTranscurrido',
        fechaEnvio: 'fechaEnvio',
        latitudRetomo: 'latitudRetomo',
        longitudRetomo: 'longitudRetomo',
        fechaRetomo: 'fechaRetomo',
        observacion: 'observacion',
      },
    }
  },
  watch: {
    selectProyecto: {
      async handler() {
        // await this.loadProyecto()
        await this.generateReportEncuestado()
        await this.generateReportMap()
        await this.generateReportAll()
      },
    },
    selectEncuesta: {
      async handler() {
        await this.generateReportEncuestado()
        await this.generateReportMap()
        await this.generateReportAll()
      },
    },
    fechaInicio: {
      async handler() {
        await this.generateReportEncuestado()
        await this.generateReportMap()
        await this.generateReportAll()
      },
    },
    fechaFinal: {
      async handler() {
        await this.generateReportEncuestado()
        await this.generateReportMap()
        await this.generateReportAll()
      },
    },
  },
  async mounted() {
    this.fechaInicio = moment().format('YYYY-MM-DD')
    this.fechaFinal = moment().format('YYYY-MM-DD')
    await this.loadProyecto()
    await this.generateReportEncuestado()
    await this.generateReportMap()
    await this.generateReportAll()
  },
  setup() {
    const {
      navbarTypeClass,
      navbarBackgroundColor,
    } = useAppConfig()

    return {
      navbarTypeClass,
      navbarBackgroundColor,
    }
  },
  methods: {
    async generarConsolidado() {
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_CONSOLIDADO_FICHA',
          {
            idEncuesta: this.selectEncuesta,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            selectUsuario: this.selectUsuario,
          })
        .then(res => {
          const a = document.createElement('a')
          a.target = '_blank'
          a.href = res
          a.download = 'descargar.xls'
          a.click()
        })
        .catch(error => {
          console.log(error)
        })
    },
    async generarConsolidado2() {
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_CONSOLIDADO_FICHA_2',
          {
            idEncuesta: this.selectEncuesta,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            selectUsuario: this.selectUsuario,
          })
        .then(res => {
          const a = document.createElement('a')
          a.target = '_blank'
          a.href = res
          a.download = 'descargar.xls'
          a.click()
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getFicha() { // https://dev.regionsanmartin.gob.pe
      const response = await axios.get(`https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/encuesta/findFichaParsed?idEncuesta=${this.selectEncuesta}&fechaInicio=${this.fechaInicio}&fechaFinal=${this.fechaFinal}&idUsuario=${this.selectUsuario}`)
      return response.data
    },
    async generateReportMap() {
      // this.$forceUpdate()
      this.dataMap = []
      this.metaEncuesta = 0
      if (this.selectEncuesta !== '') {
        await store
          .dispatch('gsencuesta/ENCUESTA_FIND_FICHA', {
            idEncuesta: this.selectEncuesta,
            idProyecto: this.selectProyecto,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            idUsuario: this.selectUsuario,
          })
          .then(response => {
            if (response !== undefined) {
              this.dataMap = response
              this.totalFicha = response.length
              this.$refs.refGoogleMaps.generateMapa(this.dataMap)
            }
          })
          .catch(error => {
            this.$bvToast.toast(error, {
              title: 'He ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
        const filterQuiz = _.findWhere(this.optionEncuesta, { idEncuesta: this.selectEncuesta })
        this.infoEncuesta = (filterQuiz === undefined) ? '' : filterQuiz.descripcion
        // console.log(filterQuiz)
        this.meta = (filterQuiz === undefined) ? '' : filterQuiz.meta
        this.metaEncuesta = this.meta
      } else {
        this.dataMap = []
        this.$refs.refGoogleMaps.generateMapa(this.dataMap)
      }
    },
    async generateReportEncuestado() {
      this.loadState()
      this.dataEncuestador = []
      // this.selectEncuesta = []
      this.meta = 0
      this.totalBeneficiario = 0
      this.totalFicha = 0
      if (this.selectProyecto !== '') {
      // this.$forceUpdate()
        await store
          .dispatch('gsencuesta/TABLERO_INDICADOR_ENCUESTADOR_FIND_ALL', {
            limit: 100,
            query: '',
            page: 1,
            sortBy: 'idProyectoUsuario%7CDESC',
            idEncuesta: (this.selectEncuesta === '') ? -1 : this.selectEncuesta,
            idProyecto: this.selectProyecto,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            idUsuario: this.selectUsuario,
          })
          .then(response => {
            if (response !== undefined) {
              this.dataEncuestador = response.items
              this.totalBeneficiario = response.items.length
              this.$refs.refEncuestado.generateListEncuestado(this.dataEncuestador)
            }
          })
          .catch(error => {
            this.$bvToast.toast(error, {
              title: 'He ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
      }
    },
    async generateReportAll() {
      this.dataEncuestador = []
      this.dataReport = {}
      if (this.selectProyecto !== '') {
      // this.$forceUpdate()
        this.isBusyReport = true
        await store
          .dispatch('gsencuesta/TABLERO_INDICADOR_REPORT_ALL', {
            idEncuesta: (this.selectEncuesta === '') ? -1 : this.selectEncuesta,
            idProyecto: this.selectProyecto,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
          })
          .then(response => {
            if (response !== undefined) {
              // console.log('suscribiendose api..')
              this.dataReport = response
              this.formTypeUbigeo = 'show'
              // this.meta, this.totalBeneficiario, this.totalFicha
              const mut = {
                oper: 'show',
                data: response,
                torta: {
                  meta: this.meta,
                  totalBeneficiario: this.totalBeneficiario,
                  totalFicha: this.totalFicha,
                },
              }
              this.$store.commit('gsencuesta/OPERACION_INDICADOR', mut)
            }
          })
          .catch(error => {
            this.$bvToast.toast(error, {
              title: 'He ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
        await store
          .dispatch('gsencuesta/TABLERO_INDICADOR_LINEA_TIEMPO', {
            idEncuesta: (this.selectEncuesta === '') ? -1 : this.selectEncuesta,
            idProyecto: this.selectProyecto,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
          })
          .then(response => {
            if (response !== undefined) {
              this.dataReportLineaTiempo = response
            }
          })
          .catch(error => {
            this.$bvToast.toast(error, {
              title: 'He ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
        this.$refs.refReport.generateReport(this.dataReportLineaTiempo)
      }
    },
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      localStorage.removeItem('userData')
      localStorage.removeItem('user-token')
      localStorage.removeItem('userProfile')
      this.$ability.update(initialAbility)
      this.$router.push({ name: 'auth-login' })
    },
    getSelectedProyecto(option) {
      this.selectEncuesta = ''
      this.optionEncuesta = []
      this.excelFicha = false
      this.excelFichaConsolidado = false
      if (option !== '') {
        this.loadEncuesta(option)
      }
    },
    loadState() {
      const mut0 = {
        oper: 'list',
        data: {},
      }
      this.$store.commit('gsencuesta/OPERACION_INDICADOR', mut0)
    },
    getSelectedEncuesta() {
      this.selectEncuesta = ''
      this.optionEncuesta = []
      this.excelFicha = false
      this.excelFichaConsolidado = false
    },
    async loadProyecto() {
      await store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', { // PROYECTO_FIND_ALL
          limit: -1,
          query: '',
          page: -1,
          sortBy: 'idProyecto%7CDESC',
          // idInstitucion: -1,
          idInstitucion: this.userData.idInstitucion,
        })
        .then(response => {
          if (response !== undefined && response.length > 0) {
            this.optionProyecto = response
            this.selectProyecto = response[0].idProyecto
            this.getSelectedProyecto(this.selectProyecto)
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.showToast('Su token ha expirado', 'Vuelva a ingresar sus credenciales de acceso.', 'info')
            this.logout()
          } else {
            this.showToast('He ocurrido un error', error.response.data.errorMessage, 'danger')
          }
        })
    },
    async loadEncuesta(idProyecto) {
      this.optionEncuesta = []
      await store
        .dispatch('gsencuesta/ENCUESTA_FIND_BY_PROYECTO', {
          idProyecto,
        })
        .then(response => {
          if (response !== undefined && response.length > 0) {
            this.optionEncuesta = response
            // this.infoEncuesta = response[0].descripcion
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    refetchDataMapa(response) {
      if (response && this.selectEncuesta !== '') {
        this.excelFicha = true
        this.excelFichaConsolidado = true
      } else {
        this.excelFicha = false
        this.excelFichaConsolidado = false
      }
    },
    showToast,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
